import Animation from './animation'
import * as decorations from '../decorations'
import { interpolate } from 'd3-interpolate'
import * as d3 from 'd3-selection'

class SlidingAnimation extends Animation {

  match (serie) {
    if (!this.previous.scalers.x || this.seriesChanged) {
      // We don't have previous data or series changed, so we're not sliding
      return false
    }
    let domain0 = this.previous.scalers.x.groupScale.domain()
      , domain1 = this.scalers.x.groupScale.domain()
      , plot0 = this.previous.scalers.x.plotScale.domain()
      , plot1 = this.scalers.x.plotScale.domain()

    return domain0[0] !== domain1[0] || // Start ticks don't match
           domain0[domain0.length - 1] !== domain1[domain1.length - 1] || // End ticks don't match
           plot0.every((id, i) => id != plot1[i])

  }

  animate (serie, entering, selection, merged, exiting) {
    let domain0 = this.previous.scalers.x.groupScale.domain()
      , domain1 = this.scalers.x.groupScale.domain()
      , xScale = this.scalers.x
      , serieScale = this.serieScale
      , strokeWidth = this.strokeWidth
      , labelsConfig = this.labelsConfig
      , prev = this.previous.allSerieTypes[serie.id].serie
      , prevSerieScale = prev.node().parentNode.__bar.serieScale

    // entering nodes start at full height
    entering.append('rect')
            .attr('y', d => this.yScale(Math.max(0, d._range[1])))
            .attr('height', d => Math.abs(this.yScale(d._range[0]) - this.yScale(d._range[1])))
            .attr('width', prevSerieScale.bandwidth()) // start at previous width, it will transition to new width
            .attr('x', d => {
              // This point is sliding in
              let idx = this.scalers.x.groupScale.domain().indexOf(d.rangeId)
                , prevStartIdx = domain1.indexOf(domain0[0])
                , prevEndIdx = domain1.indexOf(domain0[domain0.length - 1])
                , prevEndLocation = this.previous.scalers.x.groupScale(domain0[domain0.length - 1])
                , step = this.previous.scalers.x.groupScale.step()

              if (idx < prevStartIdx) {
                // Coming in from the left
                return step * (idx - prevStartIdx)  + prevSerieScale(serie._columnIdx)
              } else if (idx > prevEndIdx) {
                return step * (idx - prevEndIdx) + prevSerieScale(serie._columnIdx) + prevEndLocation
              }
            })

    // Adjust decorations
    entering.call(decorations.default, this.previous.strokeWidth)

    // Now move previous + new
    merged.tween('decorations', this.tweeners.decorations)
          .tween('all', this.tweeners.all)

    // Points in a serie that were removed from the slide
    // Remove the points in this serie by sliding them out of view
    exiting.tween('decorations', this.tweeners.decorations)
           .tween('slide-out', function (d) {
             // This rect is being removed because it's sliding out of view
             let container = d3.select(this)
               , rect = container.select('rect')
               , x0 = rect.attr('x')
               , idx = domain0.indexOf(d.rangeId)
               , prevStart = domain0.indexOf(domain1[0])
               , prevEnd = domain0.indexOf(domain1[domain1.length - 1])
               , step = xScale.groupScale.step()
               , newStartPosition = xScale.groupScale(domain1[0])
               , newEndPosition = xScale.groupScale(domain1[domain1.length - 1])
               , interpolateWidth = interpolate(rect.attr('width'), serieScale.bandwidth())
               , x1 = x0

               if (idx < prevStart) {
                 // Slide this out to the left
                 x1 = newStartPosition - step * (prevStart - idx) + prevSerieScale(serie._columnIdx)
               } else if (idx > prevEnd) {
                 // Slide this to the right
                 x1 = newEndPosition + (step * (idx - prevEnd) + prevSerieScale(serie._columnIdx))
               }

               let interpolateX = interpolate(x0, x1)

               return t => {
                 let x = interpolateX(t)
                   , width = interpolateWidth(t)

                 rect.attr('x', x)
                 rect.attr('width', width)

                 container.call(decorations.position, strokeWidth, {x, width}, labelsConfig)
               }
           })
           .remove()
  }

}

export default SlidingAnimation
